/**
 * DiagnosticBlockBanner — shared component for rendering blocking
 * diagnostics in deploy, simulation, adversarial, and graph panels.
 *
 * Displays a compact list of blocking diagnostics with code + message.
 * No duplicate formatting logic across panels.
 */

import type { MistDiagnostic } from '../../editor/diagnosticTypes';
import { STAGE_LABELS } from '../../editor/diagnosticCodes';
import styles from './DiagnosticBlockBanner.module.css';

interface DiagnosticBlockBannerProps {
  diagnostics: MistDiagnostic[];
  label: string;
}

export function DiagnosticBlockBanner({ diagnostics, label }: DiagnosticBlockBannerProps) {
  if (diagnostics.length === 0) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.header}>
        <span className={styles.icon}>✖</span>
        <span className={styles.label}>{label}</span>
      </div>
      <ul className={styles.list}>
        {diagnostics.map((d, i) => (
          <li key={`${d.code}-${i}`} className={styles.item}>
            <span className={styles.code}>{d.code}</span>
            <span className={styles.message}>{d.message}</span>
            <span className={styles.stage}>{STAGE_LABELS[d.stage] ?? d.stage}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
